import React, { useEffect, useState } from "react"
import moment from "moment"
import { browserHistory } from "react-router"
import { callEDataVoiceApi } from "../../Lib/EDVApiClient"
import Datetime from "react-datetime"
import Loader from '../../Components/Loader'
import { Campagne } from "../../types/MarketingCampaign"

interface Site
{
    id: string;
    name: string;
}

interface Link
{
    url: string
    label: string
    page: number
    active: boolean
}

interface CampagneByDealership
{
    campaign: Campagne;
    dealership: Site;
    leads_targets_count: number
    processed_actions_targets_count: number
    processed_leads_targets_count: number
    processed_targets_count: number
    total_targets_count: number
    unassigned_targets_count: number
    actions_targets_count: number
    assigned_targets_count: number
}

interface ApiResponse
{
    data: CampagneByDealership[];
    links: Link[];
    meta: {
        current_page: number;
        from: number;
        last_page: number;
    }
}

export default function CampagneDistribution(props: any) {
    moment.locale("fr")

    const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const [ campagnes, setCampagnes ] = useState<CampagneByDealership[]>([])
    const [ sites, setSites ] = useState<Site[]>([])
    const [ links, setLinks ] = useState<Link[]>([])
    const [ filters, setFilters ] = useState({
        status: 'IP' as string,
        is_recurring: false as boolean,
        start_date: '' as string | null,
        end_date: '' as string | null,
        dealership_id: '' as string | null,
    })
    const [ datePickerStartIsOpen, setDatePickerStartIsOpen ] = useState<boolean>(false)
    const [ datePickerEndIsOpen, setDatePickerEndIsOpen ] = useState<boolean>(false)

    useEffect(() => {
        fetchCampagnes()
    }, [ filters ])

    useEffect(() => {
        if (campagnes.length !== 0) {
            getSiteListOfCampagnes()
        }
    }, [ campagnes ])

    const fetchCampagnes = async () => {
        try {
            setIsLoading(true)
            const params = new URLSearchParams()

            params.append("filter[campaign.is_recurring]", String(filters.is_recurring))

            if (filters.status) params.append("filter[campaign.status]", filters.status)
            if (filters.start_date) params.append("filter[campaign.start_date]", ">" + moment(filters.start_date).subtract(1, "days").format("YYYY-MM-DD"))
            if (filters.end_date) params.append("filter[campaign.end_date]", "<" + moment(filters.end_date).add(1, "days").format("YYYY-MM-DD"))
            if (filters.dealership_id) params.append("filter[dealership.id]", String(filters.dealership_id))
            
            const response = await callEDataVoiceApi<ApiResponse>(`marketing-campaigns/by-dealership?${params.toString()}`)

            setCampagnes(response.data)
            setLinks(response.links)
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }

    const fetchCampaignsByUrl = async (url: string) => {
        try {
            setIsLoading(true)
            const response = await callEDataVoiceApi<ApiResponse>(url)
            setCampagnes(response.data)
        } catch (err) {
            console.error(err)
        } finally {
            setIsLoading(false)
        }
    }

    const onChangeTab = (tab: boolean) => {
        setFilters({
            ...filters,
            is_recurring: tab,
        })
    }

    const getSiteListOfCampagnes = () => {
        const existingSites: Site[] = sites ? sites : []
        campagnes.forEach((campagne: CampagneByDealership) => {
            if (campagne.dealership && !existingSites.find(site => site.id === campagne.dealership.id)) {
                existingSites.push(campagne.dealership)
            }
        })
        setSites(sites)
    }

    return (
        <div>
            <ul className={"nav nav-tabs eseller"} style={{ marginBottom: "15px" }}>
                <li className={"nav-item " + (filters.is_recurring ? "" : "active")}>
                    <a className={"nav-link"} role="tab" data-toggle="tab" href="#ponctuelles" onClick={() => onChangeTab(false)}>Ponctuelles</a>
                </li>
                <li className={"nav-item " + (filters.is_recurring ? "active" : "")}>
                    <a className={"nav-link"} role="tab" data-toggle="tab" href="#recurrentes" onClick={() => onChangeTab(true)}>Récurrentes</a>
                </li>
            </ul>

            <div className="row" style={{ marginBottom: "15px" }}>
                <div className="datepicker-center">
                    <div className="col-md-6" style={{ display: "flex", alignItems: "center", paddingLeft: "20px" }}>
                        <Datetime
                            locale="fr"
                            timeFormat={false}
                            open={datePickerStartIsOpen}
                            onFocus={() => setDatePickerStartIsOpen(true)}
                            onBlur={() => setDatePickerStartIsOpen(false)}
                            inputProps={{
                                readOnly: true,
                                style: { cursor: "pointer" },
                                placeholder: "JJ/MM/AAAA",
                            }}
                            onChange={(date) => {
                                let formattedDate = ""
                                if (moment.isMoment(date)) {
                                    formattedDate = date.format('YYYY-MM-DD')
                                } else if (typeof date === "string" && date !== "") {
                                    formattedDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                }
                                setFilters({
                                    ...filters,
                                    start_date: formattedDate,
                                })
                                setDatePickerStartIsOpen(false)
                            }}
                            value={filters.start_date}
                        />
                        <i className="fa fa-chevron-right" aria-hidden="true" style={{ verticalAlign: 'bottom', margin: "0 10px" }}></i>
                        <Datetime
                            className="datetime datetime_end"
                            locale="fr"
                            timeFormat={false}
                            open={datePickerEndIsOpen}
                            onFocus={() => setDatePickerEndIsOpen(true)}
                            onBlur={() => setDatePickerEndIsOpen(false)}
                            inputProps={{
                                readOnly: true,
                                style: { cursor: "pointer" },
                                placeholder: "JJ/MM/AAAA",
                            }}
                            onChange={(date) => {
                                let formattedDate = ""
                                if (moment.isMoment(date)) {
                                    formattedDate = date.format('YYYY-MM-DD')
                                } else if (typeof date === "string" && date !== "") {
                                    formattedDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
                                }
                                setFilters({
                                    ...filters,
                                    end_date: formattedDate,
                                })
                                setDatePickerEndIsOpen(false)
                            }}
                            value={filters.end_date}
                        />
                        <div className="col-md-3">
                            <button className="btn btn-default" onClick={() => setFilters({ ...filters, start_date: '', end_date: '' })}>Réinitialiser</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-3">
                    <select className="form-control" value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
                        <option value="IP">En cours</option>
                        <option value="CP">Terminé</option>
                    </select>
                </div>
                <div className="col-md-3">
                    <select className="form-control" value={filters.dealership_id} onChange={(e) => setFilters({ ...filters, dealership_id: e.target.value })}
                            style={{ paddingRight: "20px" }}>
                        <option value="">Touts les sites</option>
                        {sites && sites.map((site: Site, i: number) => (
                            <option key={i} value={site.id}>{site.name}</option>
                        ))}
                    </select>
                </div>

            </div>

            <table className="table table-eseller-lead table-striped" style={{ marginBottom: "15px" }}>
                <thead>
                <tr>
                    <th>Site</th>
                    <th>Date début</th>
                    <th>Date fin</th>
                    <th>Nom</th>
                    <th>Sujet</th>
                    <th>Objectif</th>
                    <th>Fiches affectées</th>
                    <th>Performance</th>
                </tr>
                </thead>
                {isLoading ? (
                        <tbody>
                        <tr>
                            <td colSpan={8} style={{ padding: 0 }}>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: "200px",
                                        width: "100%",
                                    }}
                                >
                                    <Loader/>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    ) :
                    (<tbody>
                    {campagnes.map((data: CampagneByDealership, i) => {
                        const percent = data.total_targets_count > 0 ? Math.min(100, (data.processed_targets_count / data.total_targets_count) * 100) : 0
                        let barClass = "progress-bar"
                        if (percent <= 30) {
                            barClass += " progress-bar-danger" // rouge
                        } else if (percent <= 70) {
                            barClass += " progress-bar-warning" // jaune
                        } else {
                            barClass += " progress-bar-success" // vert
                        }

                        // onclick go to campagne detail page
                        return (<tr key={i} onClick={() => { browserHistory.push("/campagnes-marketing/" + data.campaign.id + "?dealership_id=" + data.dealership.id) }}
                                    style={{ cursor: "pointer" }}>
                            <td> {data.dealership.name ? data.dealership.name : null}</td>
                            <td>{data.campaign.start_date ? moment(data.campaign.start_date).format('DD/MM/YYYY') : null}</td>
                            <td>{data.campaign.end_date ? moment(data.campaign.end_date).format('DD/MM/YYYY') : null}</td>
                            <td>{data.campaign.name}</td>
                            <td>{data.campaign.subject}</td>
                            <td>{data.campaign.goal}</td>
                            <td>{data.assigned_targets_count + ' sur ' + data.total_targets_count}</td>
                            <td style={{ display: "flex", alignItems: "center", justifyItems: "center", flexDirection: "row", gap: "4px" }}>
                                <div className="progress" style={{ width: "100%", marginBottom: "0" }}>
                                    <div
                                        className={barClass}
                                        role="progressbar"
                                        aria-valuenow={percent}
                                        aria-valuemin={0}
                                        aria-valuemax={100}
                                        style={{ width: `${percent}%` }}
                                    />
                                </div>
                                <span>{Math.round(percent)}%</span>
                            </td>
                        </tr>)
                    })}
                    </tbody>)
                }
            </table>
            {/*    manage pages */}
            <div className="row">
                <div className="col-md-12 text-center">
                    {links && links.map((link: Link, i: number) => (
                        <button
                            key={link.label}
                            className={`btn btn-default${link.active ? " active" : ""}`}
                            disabled={!link.url}
                            onClick={() => link.url && fetchCampaignsByUrl(link.url)}
                            dangerouslySetInnerHTML={{ __html: link.label }}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}